<template>
  <span class="orderInfoKeyValue" :style="{'-webkit-line-clamp': maxLine}">
    <span class="key">{{ keyName }}</span>
    <span class="middle">: </span>
    <span class="value" :style="{color: valueColor}">{{ value }}</span>
    <div style="clear:both;"></div>
  </span>
</template>

<script>
export default {
  name: "OrderInfoKeyValue",
  props: {
    keyName: String,
    valueColor: {
      type: String,
      default: "black"
    },
    value:{

    },
    maxLine: {
      type: Number,
      default: 4
    }
  }
}
</script>

<style lang="less">
.orderInfoKeyValue {
  display: block;
  font-size: 14px;
  line-height: 25px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  span {
    //float: left;
    &.key {
      color: black;
      display: inline-block;
      text-align: justify;
      width: 20%;
      font-weight: bolder;
      text-align-last:justify;
      :after {
        content:'.';
        width: 100%;
        display: inline-block;
        overflow: hidden;
        height: 0;
      }
    }
    &.middle {
      color: black;
      text-align: center;
      display: inline-block;
      width: 5%;
    }
    &.value {
      width: 75%;
    }
  }


}
</style>